import { TableHeader } from '@/types';

const TableColumns: () => TableHeader[] = () => {
  return [
    {
      id: 'show_name',
      label: 'Show',
      sortable: true,
      className: 'min-w-[50dvw] md:min-w-[340px]',
      styleOptions: { minWidth: 340 },
    },
    {
      id: 'brand',
      label: 'Advertiser',
      sortable: true,
      className: 'min-w-[50dvw] md:min-w-[210px]',
      styleOptions: { minWidth: 210 },
    },
    {
      id: 'campaign_type',
      label: 'Campaign type',
      sortable: true,
      className: 'min-w-[50dvw] md:min-w-[160px]',
      styleOptions: { minWidth: 160 },
    },
    {
      id: 'campaign_start_at',
      label: 'Campaign start',
      sortable: true,
      className: 'min-w-[50dvw] md:min-w-[140px]',
      styleOptions: { minWidth: 140 },
    },
    {
      id: 'campaign_end_at',
      label: 'Campaign end',
      sortable: true,
      className: 'min-w-[50dvw] md:min-w-[130px]',
      styleOptions: { minWidth: 130 },
    },
    {
      id: 'impressions',
      label: 'Est. impressions',
      sortable: true,
      className: 'min-w-[50dvw] md:min-w-[120px]',
      styleOptions: {
        align: 'right',
        minWidth: 120,
      },
    },
    {
      id: 'amount',
      label: 'Est. earnings',
      sortable: true,
      className: 'min-w-[50dvw] md:min-w-[140px]',
      styleOptions: {
        align: 'right',
        minWidth: 140,
      },
    },
  ];
};

export default TableColumns;
